// The default reading speed is set to 250 words per minute.
// This rate is an average based on extensive research into reading habits.
// https://www.sciencedirect.com/science/article/abs/pii/S0749596X19300786
// Users can adjust this setting to match their reading speed or the specific
// requirements of different text types.
export const WORDS_PER_MINUTE = 250;

export const CJK_WORDS_PER_MINUTE = 500;
